import { themes } from '../data';

export default {
  isSound: false,
  isMusic: false,
  theme: themes.numbers
}